import React, { Component } from 'react';

import ImageSrcSet from '../../ImageSrcSet'

import './Image.scss';

export default class Image extends Component {

    render() {
        const {image} = this.props;

        return (
            <div className="Image">
                <ImageSrcSet {...image} />

                <div className="Image__inner">
                    <p className="Image__text">
                        {image.text}
                    </p>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/DetailPage/Image/index.js